import { ExtendedCarItemType } from '@/interfaces/cars.interfaces';

const getCarTitle = (extendedData: ExtendedCarItemType): string => {
  const { model } = extendedData.data;
  if (model?.displayName) {
    return model.displayName;
  }
  return '';
};

export default getCarTitle;
